/**
 * Min-height for parent containers with sticky columns.
 * Ensures the container is tall enough for sticky behavior to work properly.
 */
export const STICKY_CONTAINER_STYLE = {
  minHeight: 'calc(100svh - var(--impersonation-banner-height, 0px) - 10.5rem)',
};

/**
 * Standard column width classes for sidebar/context columns.
 * w-[280px] below 2xl, w-80 (320px) at 2xl+.
 */
export const STICKY_COLUMN_CLASSES = 'w-[280px] 2xl:w-80 shrink-0';
